import React from 'react'
import Manager from '../../public/components/Manager'
import PurchaseDiv from './PurchaseDiv'
Ext.require('Ext.Toast')

const config = {
	tabs: {
		申请中: {
			buttons: [
			],
			columns: [
				{ _text: '采购单号', field: 'Number', minWidth: 150, search: true, flex: 1 },
				{ _text: '供应商名称', field: 'Supplier', minWidth: 150, search: true, flex: 1 },
				{ _number: '支付金额', field: 'LCTaxAmount', minWidth: 150, flex: 1 },
				{ _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1 },
				{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, flex: 1 },
				{ _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
			],
			onDoubleTap: ({ showDetail, refreshPage }, data) => {
				showDetail(props => <PurchaseDiv {...props} id={data.id} onSave={refreshPage} />)
			}
		},
		退回申请: {
			buttons: [
			],
			columns: [
				{ _text: '采购单号', field: 'Number', minWidth: 150, search: true, flex: 1 },
				{ _text: '供应商名称', field: 'Supplier', minWidth: 150, search: true, flex: 1 },
				{ _number: '支付金额', field: 'LCTaxAmount', minWidth: 150, flex: 1 },
				{ _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1 },
				{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, flex: 1 },
				{ _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
			],
			onDoubleTap: ({ showDetail, refreshPage }, data) => {
				showDetail(props => <PurchaseDiv {...props} id={data.id} onSave={refreshPage} />)
			}
		},
		签核中: {
			buttons: [
			],
			columns: [
				{ _text: '采购单号', field: 'Number', minWidth: 150, search: true, flex: 1 },
				{ _text: '供应商名称', field: 'Supplier', minWidth: 150, search: true, flex: 1 },
				{ _number: '支付金额', field: 'LCTaxAmount', minWidth: 150, flex: 1 },
				{ _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1 },
				{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, flex: 1 },
				{ _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
			],
			onDoubleTap: ({ showDetail, refreshPage }, data) => {
				showDetail(props => <PurchaseDiv {...props} id={data.id} onSave={refreshPage} readOnly={true} />)
			}
		},
		已完成: {
			buttons: [
			],
			columns: [
				{ _text: '采购单号', field: 'Number', minWidth: 150, search: true, flex: 1 },
				{ _text: '供应商名称', field: 'Supplier', minWidth: 150, search: true, flex: 1 },
				{ _number: '支付金额', field: 'LCTaxAmount', minWidth: 150, flex: 1 },
				{ _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1 },
				{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, flex: 1 },
				{ _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
			],
			onDoubleTap: ({ showDetail, refreshPage }, data) => {
				showDetail(props => <PurchaseDiv {...props} id={data.id} onSave={refreshPage} readOnly={true} tabName='已完成' />)
			}
		},
	}
}

export default props => <Manager {...props} config={config} />